// Canonical list of location types that physically hold / receive stock.
// 'zone' is deliberately excluded — it is a sub-area under a warehouse, not a stock-bearing shipping node.
export const STOCKABLE_LOCATION_TYPES = ["warehouse", "plant", "bin", "3p_virtual_warehouse"];

// Filter a raw locations array to active, stockable locations for use in warehouse dropdowns.
export function stockableLocations(locations) {
  return (locations || []).filter(
    (l) => l && l.status === "active" && STOCKABLE_LOCATION_TYPES.includes(l.location_type)
  );
}
